"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasProp = void 0;
const hasProp = (obj, prop) => {
  return typeof obj === 'object' && obj !== null && prop in obj;
};
exports.hasProp = hasProp;
